const namespace = '_TOOLTIP';

export const CONSTANTS = {
    SET_TOOLTIP_DATA: `${namespace}_SET_TOOLTIP_DATA`,
    REMOVE: `${namespace}_REMOVE`,
    CANCEL_REMOVE: `${namespace}_CANCEL_REMOVE`,
};
